class JsonApi {
  async get(url, body) {
    const res = await fetch(url, {
      body: JSON.stringify(body),
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }),
    });
    const response = await res.json();
    return response;
  }

  async post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }),
    });
    const response = await res.json();
    return response;
  }
}

export default JsonApi;
